import React,{useState} from 'react'
import './Smarttask.css'

const Smartdetails = ({tab, returntab}) => {
    const [active, setActive] = useState('1')

    const handleonClicked = (e) =>{
      setActive(e.target.id)
      tab(e.target.innerHTML)
    }

    const handleback = () =>{
      returntab()
    }

  return (
    <div className='smartask-main-container'>
        <span onClick={handleback} id='back-butn-task'>Back</span>
        <span id='1' className={active === '1' ? 'spactive' : ''} onClick={handleonClicked}>Details</span>
        <span id='2' className={active === '2' ? 'spactive' : ''} onClick={handleonClicked}>Discussion</span>
    </div>
  )
}

export default Smartdetails